query InvoiceSigningPreviewApprovalMap($entityId: UUID!) {
  invoiceSigningPreviewApprovalMap(
    entityId: $entityId
    orderBy: SORT_ORDER_DESC
  ) {
    nodes {
      id
      entityId
      appId
      approvalType
      digitalSignature
      isApproval
      messageUserId
      isApproved
      isBranch
      entityApprovalId
      isErrorFound
      isPending
      isRejected
      isRevoked
      isTree
      level
      messageUserId
      name
      parentId
      subTopic
      topic
      requestedDate
      statusDate
      status
      _accountingStampDate
      _accountingStampTransactionReference
      _accountingStampUserId
      _accountingStampUserName
      _isAccountingEntryStampedComplete
      _isTransactionCancelled
    }
  }
}
